/**
 * 客户极速卖车详细信息
 */

import React, { Component } from 'react';
import { Modal, Button, Descriptions, Table } from 'antd';

// import ImageView from '../../ui/ImageView';
// import Image from '../../ui/Image';
import http from '../../../axios/http';

//极速卖车跟进记录
import FastSellRecord from './FastSellRecord';


const field = [{
    "text": "车架号",
    "field": "vin",
}, {
    "text": "车辆名称",
    "field": "name",
}, {
    "text": "车主",
    "field": "username",
}, {
    "text": "车主电话",
    "field": "tel",
}, {
    "text": "车辆类型",
    "field": "vehicleType",
}, {
    "text": "车型",
    "field": "brandModel",
}, {
    "text": "卖车时间",
    "field": "sellTime",
}, {
    "text": "提交时间",
    "field": "insertTime",
}, {
    "text": "来源",
    "field": "source",
    format: { 0: "商城首页", 1: "朋友圈广告", 2: "微信分享" }
}];

// const image = [{
//     text: '行驶证',
//     field: 'licenseImg'
// }];

const columns = [{
    title: '跟进人',
    dataIndex: 'recorder',
    width: '10%',
}, {
    title: '跟进时间',
    dataIndex: 'recordTime',
    width: '15%',
}, {
    title: '跟进情况',
    dataIndex: 'remark',
    width: '35%',
    render: (text, record, index) => {
        return (<div style={{ margin: "0px", whiteSpace: "normal" }}>{text}</div>)
    }
}];

class MemberValuateDetail extends Component {

    state = {
        image: null,
        previewVisible: false,
        previewImage: null,

        record: [],

        visible: false,
    }

    createDetail = (data) => {
        const { editData } = this.props;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let text = editData[data[i]["field"]];
            if (data[i]["format"] != null) {
                text = data[i]["format"][text];
            }
            dom.push(<Descriptions.Item key={i} label={data[i]["text"]}>{text}</Descriptions.Item>);
        }
        return dom;
    }

    // 图片列表
    // createImageDom = (field) => {
    //     let dom = [];
    //     const { editData } = this.props;
    //     const imgsInfo = editData.image;
    //     for (let i = 0; i < field.length; i += 1) {
    //         let path = imgsInfo != null && imgsInfo[field[i]["field"]] ? "data:image/jpeg;base64," + imgsInfo[field[i]["field"]] : "";
    //         let imgurl = editData[field[i]["field"]] ? editData[field[i]["field"]] : "";
    //         let img = (
    //             <Col span={4} key={i} style={{ margin: '5px 0' }}>
    //                 <Image
    //                     onlyView={true}
    //                     file={path}
    //                     text={field[i].text}
    //                     url={imgurl}
    //                 />
    //             </Col>
    //         );
    //         dom.push(img);
    //     }
    //     return (<Row>{dom}</Row>);
    // }

    loadRecord = (id) => {
        http.get({
            'url': '/fastSell/findFollowRecord',
            'data': {
                'id': id
            },
            'success': (res) => {
                this.setState({ record: res == null ? [] : res });
            }
        })
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={820}
                visible={visible}
                title="急速卖车详细"
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.print}
                footer={[
                    <Button key="record" type="primary" onClick={() => { this.setState({ visible: true }) }}>添加跟进记录</Button>,
                    <Button key="cancel" type="default" onClick={onCancel}>确定</Button>,
                ]}
            >
                <Descriptions bordered column={2}>
                    {this.createDetail(field)}
                </Descriptions>
                <br></br>
                <Table rowKey="id" columns={columns} dataSource={this.state.record} bordered pagination={false} />
                {/* {this.createImageDom(image)}
                <ImageView src={this.state.previewImage} visible={this.state.previewVisible} handleCancel={this.handleCancel} /> */}

                <FastSellRecord
                    visible={this.state.visible}
                    onCancel={() => { this.setState({ visible: false }); }}
                    editData={this.props.editData}
                    successCallback={this.loadRecord}
                />
            </Modal>
        );
    }
}


export default MemberValuateDetail;